import { render, staticRenderFns } from "./UserTripList.vue?vue&type=template&id=a0effb0a&scoped=true&"
import script from "./UserTripList.vue?vue&type=script&lang=js&"
export * from "./UserTripList.vue?vue&type=script&lang=js&"
import style0 from "./UserTripList.vue?vue&type=style&index=0&id=a0effb0a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0effb0a",
  null
  
)

export default component.exports